import styled from 'styled-components';

const HitItemStyle = styled.div`
	--hitInnerPadSize: var(--sp1-5x) var(--sp1-5x) var(--sp3x);
	--hitInnerRadiusSize: var(--sp2-5x);
	--hitInnerGap: var(--sp4x);
	--hitInnerInfoPadLR: var(--sp2x);
	--hitItemImageRadiusSize: var(--sp1-5x);
	--hitItemImageSize: 71%;

	height: 100%;

	.hit-inner-item {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: var(--hitInnerGap);
		padding: var(--hitInnerPadSize);
		padding-bottom: var(--hitInnerGap);
		background-color: var(--gray100);
		border-radius: var(--hitInnerRadiusSize);
	}

	.hit-item-info-wrapper {
		height: 100%;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.hit-item-info-inner-wrapper {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: var(--hitInnerGap);
		padding: 0 var(--hitInnerInfoPadLR);
	}

	.hit-item-date {
		text-align: right;
	}

	.hit-item-image-block {
		overflow: hidden;
		border-radius: var(--hitItemImageRadiusSize);
	}

	.hit-item-image {
		--proportion: var(--hitItemImageSize);

		transition: transform var(--trTime) ease-out !important;
		will-change: transform;

		img {
			border-radius: var(--hitItemImageRadiusSize);
			overflow: hidden;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				.hit-item-image {
					transform: scale(1.1);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--hitInnerPadSize: var(--sp1x) var(--sp1x) var(--sp3x);
		--hitInnerRadiusSize: var(--sp2-5x);
		--hitInnerGap: var(--sp4x);
		--hitInnerInfoPadLR: var(--sp2x);
		--hitItemImageRadiusSize: var(--sp1-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--hitInnerPadSize: var(--sp1x) var(--sp1x) var(--sp2-5x);
		--hitInnerRadiusSize: var(--sp2-5x);
		--hitInnerGap: var(--sp3x);
		--hitInnerInfoPadLR: var(--sp2x);
		--hitItemImageRadiusSize: var(--sp1-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--hitInnerPadSize: var(--sp1x) var(--sp1x) var(--sp2-5x);
		--hitInnerRadiusSize: var(--sp2-5x);
		--hitInnerGap: var(--sp3x);
		--hitInnerInfoPadLR: var(--sp2x);
		--hitItemImageRadiusSize: var(--sp1-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--hitInnerPadSize: var(--sp0-5x) var(--sp0-5x) var(--sp2-5x);
		--hitInnerRadiusSize: var(--sp2-5x);
		--hitInnerGap: var(--sp2-5x);
		--hitInnerInfoPadLR: var(--sp1-5x);
		--hitItemImageRadiusSize: var(--sp1-5x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--hitInnerPadSize: var(--sp0-5x) var(--sp0-5x) var(--sp2-5x);
		--hitInnerRadiusSize: var(--sp2x);
		--hitInnerGap: var(--sp2-5x);
		--hitInnerInfoPadLR: var(--sp1x);
		--hitItemImageRadiusSize: var(--sp1x);
		--hitItemImageSize: 70%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--hitInnerPadSize: var(--sp0-5x) var(--sp0-5x) var(--sp2x);
		--hitInnerRadiusSize: var(--sp2x);
		--hitInnerGap: var(--sp2x);
		--hitInnerInfoPadLR: var(--sp0-5x);
		--hitItemImageRadiusSize: var(--sp1x);
		--hitItemImageSize: 72%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--hitInnerPadSize: var(--sp0-5x) var(--sp0-5x) var(--sp2x);
		--hitInnerRadiusSize: var(--sp2x);
		--hitInnerGap: var(--sp2x);
		--hitInnerInfoPadLR: var(--sp0-5x);
		--hitItemImageRadiusSize: var(--sp1x);
		--hitItemImageSize: 69%;
	}
`;

export default HitItemStyle;
